import React, { forwardRef, isValidElement } from 'react';
import { isEmpty, isNotEmpty } from '../../helpers';
import * as S from './styles';
const TOGGLE_SWITCH_ARIA_ACCESSIBILITY_LABEL_ERROR = '[ToggleSwitch - Accessibility Error] Um elemento de input deve ter um label associado. Informe pelo menos um dos atributos "label" | "aria-label" | "aria-labelledby" com valor válido.';
const validateAccessibilityLabel = ({ 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, label, }) => {
    if (isValidElement(label) || (typeof label === 'string' && isNotEmpty(label)))
        return;
    if (isEmpty(ariaLabel) && isEmpty(ariaLabelledby))
        throw new Error(TOGGLE_SWITCH_ARIA_ACCESSIBILITY_LABEL_ERROR);
};
/**
 * Componente ToggleSwitch do Design System OLX
 */
export const ToggleSwitch = forwardRef((props, ref) => {
    validateAccessibilityLabel(props);
    return (React.createElement(S.ToggleSwitchWrapper, { "data-ds-component": "DS-ToggleSwitch", isLabelVisible: props.label ? true : false, disabled: props.disabled },
        props.label && React.createElement(S.Label, null, props.label),
        React.createElement(S.NativeInput, Object.assign({ ref: ref }, props)),
        React.createElement(S.ToggleSwitchStylized, null,
            React.createElement(S.SwitchIcon, null),
            React.createElement(S.CheckedIcon, null),
            React.createElement(S.UncheckedIcon, null))));
});
ToggleSwitch.displayName = 'DS-ToggleSwitch';
